<template>
  <div class="index">
    <div class="header">
      <div class="main">
        <div class="main-left">
          <img src="../../static/broadcast.png" alt="" /> 查政策，找服务，上荷塘查策网！
        </div>
        <login-nav></login-nav>
      </div>
    </div>

    <div class="maintion">
      <div class="bread-nav">
        <img src="../../static/hourse.png" alt="" />
        <div>
          <span style="cursor: pointer" @click="$router.push('/')">首页</span> /
          <span @click="backPage" style="cursor: pointer">{{
            status == 1
              ? "政策文件"
              : status == 2
              ? "政策产品"
              : status == 3
              ? "政策解读"
              : status == 5
              ? "免申即享"
              : status == 6
              ? "活动中心"
              : ""
          }}</span>
          /
          <span>
            {{ status == 5 ? "免申即享详情" : status == 6 ? "活动详情" : "政策详情" }}
          </span>
        </div>
      </div>
      <div class="product">
        <p class="cujin">
          {{ info.title }}
        </p>
        <div class="address">
          <div>
            <img src="../../static/liucheng.png" alt="" />
            <span v-if="status == 6">{{ info.address }}</span>
            <span v-else>{{ status != 1 && status != 2 ? info.source : info.dept }}</span>
            <span style="color: gray; margin: 0 5px"> |</span>
            <span
              v-if="
                info.updateDateTime ||
                info.startTime ||
                info.starttime ||
                info.apply_time ||
                info.time_str
              "
            >
              {{
                status == 1
                  ? info.updateDateTime.split(" ")[0]
                  : status == 2
                  ? info.startTime + " ~ " + info.endTime
                  : status == 3
                  ? info.starttime + " ~ " + info.endtime
                  : status == 5
                  ? info.apply_time
                  : info.time_str
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="detail">
        <!-- <div class="title">
          <div class="det">项目详情</div>
        </div> -->
        <div class="content" v-if="status == 1">
          <div class="type-shen">
            <div class="title-tpye">
              <p><img src="../../static/circleyuanquan.png" alt="" />政策依据</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" style="min-height: 70px">
              {{ info.title }}
              <p>
                <a :href="info.originalUrl" target="_">{{ info.originalUrl }}</a>
              </p>
            </div>
          </div>
          <div class="type-shen">
            <div class="title-tpye">
              <p><img src="../../static/shaixuan.png" alt="" />{{ info.plate }}</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div
              class="type-p"
              v-if="info.content"
              v-html="info.content.replace(/\n/g, '<br/>')"
            ></div>
          </div>
        </div>
        <div class="content" v-else-if="status == 2">
          <div class="type-shen" v-if="info.announcements">
            <div class="title-tpye">
              <p><img src="../../static/shaixuan.png" alt="" />事项名称</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.announcements.split(/\n/g)[0]"></div>
          </div>
          <div class="type-shen" v-if="info.materials">
            <div class="title-tpye">
              <p><img src="../../static/cailiaochangjia.png" alt="" />受理条件</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.materials.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.materials">
            <div class="title-tpye">
              <p><img src="../../static/circleyuanquan.png" alt="" />支持力度</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.materials.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.condition">
            <div class="title-tpye">
              <p><img src="../../static/039shuangshou.png" alt="" />申报材料</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.condition.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.announcements">
            <div class="title-tpye">
              <p><img src="../../static/039shuangshou.png" alt="" />政策依据</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p">
              <a :href="info.announcements.split(/\n/g)[1]">{{info.announcements.split(/\n/g)[1]}}</a>
            </div>
          </div>
        </div>
        <div class="content" v-else-if="status == 3">
          <div class="type-shen" v-if="info.laiyuan">
            <div class="title-tpye">
              <p><img src="../../static/shaixuan.png" alt="" />事项名称</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.laiyuan.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.tiaojian">
            <div class="title-tpye">
              <p><img src="../../static/cailiaochangjia.png" alt="" />受理条件</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.tiaojian.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.lidu">
            <div class="title-tpye">
              <p><img src="../../static/circleyuanquan.png" alt="" />支持力度</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.lidu.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.cailiao">
            <div class="title-tpye">
              <p><img src="../../static/039shuangshou.png" alt="" />申报材料</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.cailiao.replace(/\n/g, '<br/>')"></div>
          </div>
        </div>
        <div class="content" v-else-if="status == 5">
          <div class="type-shen" v-if="info.tiaojian">
            <div class="title-tpye">
              <p><img src="../../static/shaixuan.png" alt="" />申请条件</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.tiaojian.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.content">
            <div class="title-tpye">
              <p><img src="../../static/cailiaochangjia.png" alt="" />优惠内容</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.content.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.cailiao">
            <div class="title-tpye">
              <p><img src="../../static/circleyuanquan.png" alt="" />申报材料</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.cailiao.replace(/\n/g, '<br/>')"></div>
          </div>
          <div class="type-shen" v-if="info.psource">
            <div class="title-tpye">
              <p><img src="../../static/039shuangshou.png" alt="" />项目来源</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.psource.replace(/\n/g, '<br/>')"></div>
          </div>
        </div>
        <div class="content" v-else-if="status == 6">
          <div><img :src="info.image" alt="" style="width: 100%" /></div>
          <div class="type-shen" v-if="info.detail">
            <div class="title-tpye">
              <p><img src="../../static/shaixuan.png" alt="" />活动通知</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" v-html="info.detail"></div>
          </div>
          <div class="type-shen" v-if="info.detail">
            <div class="title-tpye">
              <p><img src="../../static/shaixuan.png" alt="" />参与活动</p>
              <img src="../../static/xiangxiajiantou.png" alt="" />
            </div>
            <div class="type-p" style="display: flex; justify-content: center">
              <img :src="info.ewmimage" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPolicyDetail,
  getProductDetail,
  getUnscrambleDetail,
  getShareDetail,
  getActivityDetail,
} from "@/api/index";
import loginNav from "@/components/loginNav.vue";
export default {
  components: { loginNav },
  data() {
    return {
      status: false,
      id: "",
      info: {},
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    this.getDetail();
  },
  methods: {
    backPage() {
      this.$router.push({ path: "/policy/policyDetail", query: { status: this.status } });
    },
    getDetail() {
      let data = {
        id: this.id,
      };
      if (this.status == 1) {
        getPolicyDetail(data).then((res) => {
          this.info = res.data;
        });
      } else if (this.status == 2) {
        getProductDetail(data).then((res) => {
          this.info = res.data;
        });
      } else if (this.status == 3) {
        getUnscrambleDetail(data).then((res) => {
          console.log(res);
          this.info = res.data.data;
        });
      } else if (this.status == 5) {
        getShareDetail(data).then((res) => {
          this.info = res.data.data;
        });
      } else if (this.status == 6) {
        getActivityDetail(data).then((res) => {
          // console.log(res.data);
          this.info = res.data.data;
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  // margin: 0 136px;
  .header {
    background-color: #1395f3;
    height: 50px;
    .main {
      margin: 0 136px;
      // background-color: pink;
      height: 50px;
      display: flex;
      justify-content: space-between;
      .main-left {
        font-size: 14px;
        line-height: 50px;
        color: white;
        display: flex;
        img {
          height: 20px;
          margin-top: 15px;
        }
      }
      .log {
        display: flex;
        font-size: 14px;
        line-height: 50px;
        color: white;
        align-items: center;
        .image {
          height: 18px;
          margin-top: 15px;
        }
      }
    }
  }
  .navition {
    height: 100px;
    // background-color: aqua;
    margin: 0 136px;
    display: flex;
    justify-content: space-between;
    img {
      height: 60px;
      margin-top: 20px;
    }
    .list {
      display: flex;
      list-style: none;
      width: 500px;
      li {
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 17px;
        .el-button {
          background-color: white;
          color: black;
          border: none;
        }
      }
      li:hover {
        color: #409eff;
        border-bottom: 3px solid #409eff;
      }
    }
  }
  .maintion {
    background-color: #f4f6fc;
    // height: 1200px;
    padding-bottom: 60px;
    .bread-nav {
      height: 70px;
      line-height: 70px;
      margin: 0 136px;
      // background-color: aqua;
      text-align: left;
      display: flex;
      img {
        width: 15px;
        height: 15px;
        margin-top: 27.5px;
        margin-right: 5px;
      }
    }
    .product {
      background-color: #fafbfe;
      height: 150px;
      margin: 0 136px;
      text-align: left;
      padding: 0 20px;
      margin-bottom: 20px;
      .cujin {
        height: 80px;
        line-height: 80px;
        font-size: 20px;
        font-weight: bold;
        border-bottom: 1px solid rgb(212, 210, 210);
      }
      .address {
        height: 70px;
        display: flex;
        justify-content: space-between;
        div {
          line-height: 70px;
          color: #409eff;
          font-weight: bold;
          display: flex;
          align-items: center;
          img {
            width: 17px;
            height: 17px;
            margin-right: 5px;
          }
        }
        .shouc {
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: black;
          margin-top: 20px;
          border: 1px solid #409eff;
          width: 90px;
          border-radius: 15px;
          margin-right: 20px;
          display: flex;
          img {
            width: 15px;
            height: 15px;
            margin-top: 7.5px;
            margin-left: 18px;
            margin-right: 3px;
          }
        }
        .shouhide {
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #409eff;
          margin-top: 20px;
          border: 1px solid #409eff;
          width: 90px;
          border-radius: 15px;
          margin-right: 20px;
          display: flex;
          img {
            width: 15px;
            height: 15px;
            margin-top: 7.5px;
            margin-left: 18px;
            margin-right: 3px;
          }
        }
      }
    }
    .detail {
      background-color: #fafbfe;
      // height: 400px;
      margin: 0 136px;
      .title {
        background-color: #f2f2f2;
        height: 50px;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
        .det {
          background-color: #fff;
          width: 100px;
          color: #409eff;
          text-align: center;
        }
        .time {
          width: 200px;
          margin-right: 15px;
          display: flex;
          img {
            width: 25px;
            height: 25px;
            margin-top: 12px;
          }
        }
      }
      .type {
        // background-color: #fff;
        height: 160px;
        padding: 0 15px;
        margin-bottom: 20px;
        color: #409eff;
        .title-tpye {
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          font-weight: bold;
          text-align: left;
          border-bottom: 1px solid rgb(216, 212, 212);

          p {
            display: flex;
            padding-left: 20px;
            img {
              width: 15px;
              height: 15px;
              margin-top: 22px;
              margin-right: 3px;
            }
          }
        }
        .type-list {
          height: 100px;
          display: flex;
          flex-wrap: wrap;
          padding-left: 15px;
          .type-box {
            border: 1px solid rgb(138, 134, 134);
            border-radius: 15px;
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            color: #409eff;
            // width: 85px;
            padding: 0 20px;
            margin-right: 30px;
            margin-top: 10px;
          }
        }
      }
      .type-shen {
        padding: 0 15px;
        padding-bottom: 20px;
        color: #409eff;
        .title-tpye {
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          font-weight: bold;
          text-align: left;
          border-bottom: 1px solid rgb(216, 212, 212);
          display: flex;
          justify-content: space-between;
          p {
            padding-left: 20px;
            display: flex;
            img {
              width: 15px;
              height: 15px;
              margin-top: 22px;
              margin-right: 3px;
            }
          }
          img {
            width: 20px;
            height: 20px;
            margin-top: 25px;
            margin-right: 30px;
          }
        }
        .type-p {
          line-height: 30px;
          padding: 0 20px;
          color: black;
          text-align: left;
          padding-top: 10px;
          p {
            color: #409eff;
          }
        }
      }
    }
  }
}
</style>
